import { LocationValue } from './valueObjects/LocationValue';

export class Location {
  constructor(private readonly id: number, private readonly value: LocationValue) {}

  getId() {
    return this.id;
  }

  getValue() {
    return this.value;
  }
}
